import axios from 'axios';
import { api_login_unico_url } from './Urls';

export const Api =  axios.create({
  baseURL:api_login_unico_url
});